import { ApiAttribute, EndpointAttributes } from '@context/openapi/types';

export const clearForm = (
  method: string,
  endpointAttributes: EndpointAttributes
) => {
  const endpointAttrs = [
    ...(method === 'post'
      ? endpointAttributes.params
      : endpointAttributes.queryParams),
    ...endpointAttributes.pathParameters,
  ];

  endpointAttrs.map((attribute) => {
    switch (attribute.type) {
      case 'FILTER':
        attribute.value = '';
        attribute.filter = '';
        break;
      case 'OBJECT':
        attribute.child.map((child) => {
          child.value = '';
          if (child.filter) {
            child.filter = '';
          }
        });
        break;
      case 'ARRAY':
        attribute.child = [];
        break;
      default:
        attribute.value = '';
    }
  });

  return endpointAttributes;
};

export function clearAttribute(
  method: string,
  endpointAttributes: EndpointAttributes,
  attribute: ApiAttribute
) {
  const endpointAttrs = [
    ...(method === 'post'
      ? endpointAttributes.params
      : endpointAttributes.queryParams),
    ...endpointAttributes.pathParameters,
  ];

  const targetAttr = endpointAttrs.find((attr) => attr.name === attribute.name);

  if (!targetAttr) return endpointAttributes;

  switch (targetAttr.type) {
    case 'FILTER':
      targetAttr.value = '';
      targetAttr.filter = '';
      break;
    case 'OBJECT':
      targetAttr.child.forEach((child) => {
        child.value = '';
        if (child.filter) {
          child.filter = '';
        }
      });
      break;
    case 'ARRAY':
      targetAttr.child = targetAttr.child
        .filter((child) => child.arrayIndex === 0)
        .map((child) => ({
          ...child,
          value: '',
        }));
      break;
    default:
      targetAttr.value = '';
  }

  return endpointAttributes;
}
